export let extraEntropy = false;
/** @internal */
export function setExtraEntropy(entropy) {
    extraEntropy = entropy;
}
//# sourceMappingURL=entropy.js.map